<div class="flex flex-row pb-3 justify-between relative items-center">
    <h2 class="dialog-heading"></h2>
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center"
        (click)="this._bottomSheetRef.dismiss()">
        <mat-icon class="text-orange-color text-xl">close</mat-icon>
    </button>
</div>
<div class="p-4">
    <div class="autoScroll">
        <img src="assets/images/ui/feedback.svg" alt="" class="w-24 mb-6 mx-auto">
        <h3 class="text-center text-[26px] leading-7 font-semibold text-orange-color mb-3">Pending Feedback</h3>
        <p class="text-center text-lg leading-[26px] font-medium max-w-80 mx-auto text-blue-theme-color">You have
            <strong>{{this._data}}</strong> pending orders awaiting your review and rating of the delivery personnel.
            Please share
            your feedback before
            continuing.
        </p>

    </div>

    <!-- action buttons -->
    <div class=" md-flex flex   gap-4 mt-8 w-full">

        <div class=" w-full" routerLink="/pending-feedback" (click)="this._bottomSheetRef.dismiss()">
            <button matTooltip="Log-out"
                class="!bg-orange-color w-full !rounded-lg flat-button flex justify-center items-center  !px-6 md:!h-14 sm:!h-10 !h-10 text-white-color hover:opacity-[0.9]"
                mat-flat-button>
                Review Orders
            </button>
        </div>

        <div class="w-full">
            <button (click)="this._bottomSheetRef.dismiss()"
                class="!bg-blue-theme-color w-full  !rounded-lg flex justify-center flat-button items-center  !px-6 md:!h-14 sm:!h-10 !h-10 text-white-color hover:opacity-[0.9]"
                mat-flat-button>
                Do It Later
            </button>
        </div>


    </div>
</div>